import script from "./HudOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HudOverlay.vue?vue&type=script&setup=true&lang=js"

import "./HudOverlay.vue?vue&type=style&index=0&id=59d4e8ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d4e8ad"]])

export default __exports__